import { Link, useNavigate } from "react-router-dom";
import CTAButton from './CTAButton';
import { FiPlus, FiArrowRight } from 'react-icons/fi';

const ServiceHero = ({ 
  badge, 
  title,
  logo,
  titleHighlight, 
  description,
  externalUrl,
  externalUrlText = "Visit website",
  ctaText = "Start Your Project",
  ctaLink = "/contact"
}) => {
  const navigate = useNavigate();
  return (
    <div className='relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden'>
      <div className='container-custom relative z-10'>
        <div className='flex flex-col items-center text-center px-4'>
          <div className='max-w-4xl flex gap-6 flex-col items-center'>
            {badge && (
              <div className='inline-block px-4 py-1.5 bg-brand-orange/10 rounded-full text-brand-orange text-sm font-semibolduppercase tracking-wider backdrop-blur-sm border border-brand-orange/20'>
                {badge}
              </div>
            )}
            <h1 className='text-5xl md:text-7xl font-bold leading-tight tracking-tight text-slate-900'>
              {logo ? (
                <img src={logo} alt={title} className="h-20 object-contain mx-auto" />
              ) : (
                title
              )}
            </h1>
            <p className='text-xl md:text-xl text-slate-600 leading-relaxed'>
              {description}
            </p>
            {externalUrl && (
              <a
                href={externalUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#456EF2] font-semibold hover:text-blue-700 transition-colors"
              >
                {externalUrlText}
                <FiArrowRight size={18} />
              </a>
            )}
            <div className='flex flex-col sm:flex-row gap-4 justify-center items-center'>
              <CTAButton 
                icon={FiPlus} 
                onClick={() => navigate(ctaLink)}
              >
                {ctaText}
              </CTAButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceHero;
